/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getDishView } from "../core/_requests";
import EditDish from "./EditDish";

export const EditBasicDetailsWrapper = () => {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDishData = async () => {
      try {
        const res = await getDishView(id);
        setData(res.data);
      } catch (err) {
        setError("Failed to fetch dish data.");
        console.error("Error fetching dish data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDishData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return data ? <EditDish initialValues={data} /> : <div>No data available</div>;
};
